export enum ApiResponseCode {
  Success = 'Success',
  Unknown_Scheme = 'Unknown_Scheme',
  Account_Disabled = 'Account_Disabled',
  Account_Not_Validated = 'Account_Not_Validated',
  Account_Locked = 'Account_Locked',
  Account_Password_Expired = 'Account_Password_Expired',
  Unknown_Error = 'Unknown_Error',
  Server_Error = 'Server_Error',
  Cant_Capture_Required_Funds = 'Cant_Capture_Required_Funds',
  Purse_Topup_Failed = 'Purse_Topup_Failed',
  Transaction_Already_Completed = 'Transaction_Already_Completed',
  Invalid_email_address = 'Invalid_email_address',
  Account_Does_Not_Exist = 'Account_Does_Not_Exist',
  Current_Password_Incorrect = 'Current_Password_Incorrect',
  Account_Update_Failed  = 'Account_Update_Failed',
}
